import getNative from './_getNative.js';
import root from './_root.js';

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

export default Set;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash-es/_Set.js
// module id = 1555
// module chunks = 0